<template>
  <div>
    <!-- Sidebar unique pour tous les rôles -->
    <AppSidebar v-if="authStore.isAuthenticated" ref="sidebarRef" />

    <!-- Zone de contenu principal -->
    <main
      :class="[
        'min-h-screen bg-offwhite dark:bg-navy-mid transition-all duration-300',
        authStore.isAuthenticated
          ? (sidebarCollapsed ? 'ml-[64px] p-6' : 'ml-[260px] p-6')
          : ''
      ]"
    >
      <router-view />
    </main>

    <!-- Bouton flottant de notifications -->
    <FloatingNotifications v-if="authStore.isAuthenticated" />

    <!-- Toast global PrimeVue -->
    <Toast position="bottom-right" />
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useAuthStore } from '@/stores/auth.js'
import AppSidebar from './AppSidebar.vue'
import FloatingNotifications from '@/components/common/FloatingNotifications.vue'

const authStore = useAuthStore()
const sidebarRef = ref(null)

const sidebarCollapsed = computed(() => {
  return sidebarRef.value ? sidebarRef.value.collapsed : false
})
</script>
